<!--
TODO:
* Change color theme to identical with List @ Search?
* Then adjust background pattern/color - use blue one perhaps?
-->
<template>
  <div :class="['table', editing === true ? 'table--editing' : '']">
    <table cellspacing="0" cellpadding="0" width="100%">
      <thead class="table__header">
        <tr>
          <th
            v-for="(item, y) in formattedData.header"
            :class="[formattedData.header[y].alignRight && formattedData.header[y].alignRight === true ? 'table--alignRight' : '', formattedData.header[y].extraRightPadding && formattedData.header[y].extraRightPadding === true ? 'table--extraRightPadding' : '', (windowWidth < 960 && formattedData.header[y].key === 'filters') ? 'table--hidden' : '', (windowWidth < 760 && formattedData.header[y].key === 'frequency') ? 'table--hidden' : '', windowWidth < formattedData.header[y].hiddenThreshold ? 'table--hidden' : '']"
            :width="item.width"
          >
            {{ item.value }}
          </th>
        </tr>
      </thead>

      <tbody
        v-if="formattedData.content && formattedData.content.length > 0"
        class="table__body"
      >
        <tr
          v-for="(item, x) in formattedData.content"
          @click="clicked(item)"
        >
          <td
            v-for="(value, y) in item.data"
            :class="[formattedData.header[y].capitalizeContent && formattedData.header[y].capitalizeContent === true ? 'table--capitalize' : '', formattedData.header[y].alignRight && formattedData.header[y].alignRight === true ? 'table--alignRight' : '', formattedData.header[y].lightText === true ? 'table--lightText' : '', formattedData.header[y].dimmedText === true ? 'table--dimmedText' : '', formattedData.header[y].extraRightPadding && formattedData.header[y].extraRightPadding === true ? 'table--extraRightPadding' : '', (windowWidth < 960 && formattedData.header[y].key === 'filters') ? 'table--hidden' : '', (windowWidth < 760 && formattedData.header[y].key === 'frequency') ? 'table--hidden' : '', windowWidth < formattedData.header[y].hiddenThreshold ? 'table--hidden' : '']"
          >
            <div
              :class="formattedData.header[y].key === 'name' ? 'table__flex' : ''"
              :style="{ 'width': formattedData.header[y].width }" 
            >
              <div v-html="formattedData.header[y].key === 'count' ? x+1 : (formattedData.header[y].key === 'filters' ? filterCount(value) : (formattedData.header[y].key === 'type' ? getTypeName(value) : value))" />
              <div
                v-if="formattedData.header[y].key === 'name' && showSearchLink === true"
                class="table__icon showSearchLink"
                title="View in search"
                @click.stop="redirectTo(item.type, item.query)"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M13.723 18.654l-3.61 3.609c-2.316 2.315-6.063 2.315-8.378 0-1.12-1.118-1.735-2.606-1.735-4.188 0-1.582.615-3.07 1.734-4.189l4.866-4.865c2.355-2.355 6.114-2.262 8.377 0 .453.453.81.973 1.089 1.527l-1.593 1.592c-.18-.613-.5-1.189-.964-1.652-1.448-1.448-3.93-1.51-5.439-.001l-.001.002-4.867 4.865c-1.5 1.499-1.5 3.941 0 5.44 1.517 1.517 3.958 1.488 5.442 0l2.425-2.424c.993.284 1.791.335 2.654.284zm.161-16.918l-3.574 3.576c.847-.05 1.655 0 2.653.283l2.393-2.389c1.498-1.502 3.94-1.5 5.44-.001 1.517 1.518 1.486 3.959 0 5.442l-4.831 4.831-.003.002c-1.438 1.437-3.886 1.552-5.439-.002-.473-.474-.785-1.042-.956-1.643l-.084.068-1.517 1.515c.28.556.635 1.075 1.088 1.528 2.245 2.245 6.004 2.374 8.378 0l4.832-4.831c2.314-2.316 2.316-6.062-.001-8.377-2.317-2.321-6.067-2.313-8.379-.002z"/></svg>
              </div>
            </div>
          </td>
        </tr>
      </tbody>

      <tbody
        v-else
        class="table__body"
      >
        <tr>
          <td :colspan="header.length">{{ loading === true ? 'Loading...' : (type === 'notifications' ? 'Notifications has not been set.' : 'No results...' ) }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import helperMethods from '@/helpers/utility.js'

export default {
  props: {
    type: {
      type: String,
      default: ''
    },
    dataObject: {
      type: [Object, Boolean],
      default: false
    },
    header: {
      type: Array,
      default: function () {
        return []
      }
    },
    name: {
      type: String,
      default: ''
    },
    showSearchLink: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    editing: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formattedData: {},
      windowWidth: window.innerWidth
    }
  },
  computed: {
    isAuthenticated () {
      return this.$store.getters['user/isAuthenticated']
    }
  },
  methods: {
    formatData() {
      let data = []

      if (this.dataObject) {
        Object.entries(this.dataObject.byId).forEach(([key, value]) => {
          let series = []

          this.header.forEach(headerItem => {
            let checkKey = headerItem.key

            if (this.header[checkKey] !== undefined || this.header[checkKey] !== null) {
              series.push(value.attributes[checkKey])
            }
          })

          data.push({
            id: value.id,
            type: value.attributes.type,
            query: value.attributes.query,
            url: value.attributes.url,
            data: series
          })
        })
      }

      this.formattedData = {
        header: this.header,
        content: data
      }
    },
    filterCount (filters) {
      let count = 0

      if (filters) {
        for (const [key, value] of Object.entries(filters)) {
          if (filters[key] && filters[key].length > 0) {
            count += filters[key].length
          }
        }
      }

      return count + (count === 1 ? ' filter' : ' filters')
    },
    redirectTo (type, path) {
      this.$router.push('/' + type + '?' + path)
    },
    clicked (value) {
      let result = value.id

      if (this.type === 'logs') {
        result = value.url
      }

      this.$emit('clicked', result)
    },
    onResize() {
      this.windowWidth = window.innerWidth
    },
    ...helperMethods
  },
  watch: {
    dataObject: function (a, b) {
      this.formatData()
    }
  },
  mounted() {
    this.formatData()
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.nextItem)
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/app.scss';

.table {
  @include font('content--sm', $white, 0.9);
  height: auto;
  overflow: auto;
  box-shadow: 0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12);

  /*@media screen and (min-width: $breakpointMd) {
    @include font('content--md', $white, 0.9);
  }*/

  @media screen and (min-width: $breakpointLg) {
    @include font('content--md', $white, 0.9);
    border-width: 6px 1px 1px 1px;
  }

  &--capitalize {
    text-transform: capitalize;
  }

  &--alignRight {
    text-align: right !important;
  }

  &--extraRightPadding {
    padding-right: 2.5rem !important;
  }

  &--editing {
    user-select: none !important;
  }

  &--lightText {
    color: rgba($white, 0.7) !important;
  }

  &--dimmedText {
    color: rgba($white, 0.5) !important;
  }

  &--hidden {
    display: none;
  }

  &__header {
    user-select: none;
  }

  &__icon {
    fill: rgba($blue, 0.7);
    width: 16px;
    height: 16px;
    padding-left: 8px;
    align-self: center;

    @media screen and (min-width: $breakpointLg) {
      width: 18px;
      height: 18px;
    }

    &:hover {
      fill: $blue;
      padding-left: 10px;
    }
  }

  &__flex {
    display: flex;
    align-items: stretch;
  }

  th {
    @include font('content--xs', $white, 0.5);
    background-color: $bg-2;
    font-weight: 500;
    padding: 0.6rem 0.75rem;
    text-align: left;
    text-transform: uppercase;
    border-top: 1px solid rgba($white, 0.1);
    border-bottom: 1px solid $black;
    overflow: hidden;
    white-space: nowrap;

    @media screen and (min-width: $breakpointLg) {
      @include font('content--sm', $white, 0.5);
      font-weight: 500;
      padding: 0.75rem 0.75rem;
    }
  }

  tr {
    background-color: $bg-4;
    transition: background-color 0.125s ease-out;

    &:hover {
      background-color: $bg-2; //lighten($bg-2, 7.5);
      color: $white;

      .showSearchLink {
        display: block;
        opacity: 1;
      }
    }
  }

  td {
    padding: 0.5rem 0.75rem;
    text-align: left;
    border-top: 1px solid rgba($white, 0.1);
    border-bottom: 1px solid $black;
    cursor: pointer;
  }
}

.showSearchLink {
  opacity: 0;
  display: none;
}

.table::-webkit-scrollbar {
  width: 18px;
  height: 20px;
}

.table::-webkit-scrollbar-track:horizontal {
  background-color: $bg-2;
  border-top: 1px solid $black;
  box-shadow: inset 0px 1px 0px rgba($white, 0.1);
}

.table::-webkit-scrollbar-track:vertical {
  background-color: $bg-2;
  border-left: 1px solid $black;
  box-shadow: inset 1px 1px 0px rgba($white, 0.1);
}

::-webkit-scrollbar-corner {
  background-color: $bg-2;
  border-top: 1px solid $black;
  box-shadow: inset 0px 1px 0px rgba($white, 0.1);
}

.table::-webkit-scrollbar-thumb {
  border-radius: 999px;
  border: 5px solid transparent;
  background-clip: content-box;
  background-color: rgba($black, 0.5);
}

.table::-webkit-scrollbar-thumb:hover {
  border: 3px solid transparent;
}

.table::-webkit-scrollbar-thumb:active {
  background-color: $black;
}

</style>
